import styled, { css } from 'styled-components';
import { Card, mediaMixin } from '@zillow/constellation';

export const StyledCard = styled(Card)`
  background-color: transparent;
  text-align: center;
  ${mediaMixin(
    'lg',
    css`
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
    `,
  )}
`;

export const StyledCenterAlignedContainer = styled.div`
  text-align: center;
`;
